module.exports = __webpack_public_path__ + "img/transfer-bg.3fe38090.svg";